<template>
  <div>
    <div class="product-ranges">
      <div class="block-size-range">
        <label v-if="label">{{ label }}</label>
        <input
          type="range"
          class="slider"
          :min="min"
          :max="max"
          :step="step"
          data-index="option1"
          data-range="size"
          style=""
          ref="slider"
          v-model="rangeValue"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProductRangeSlider",
  props: {
    label: String,
    options: Array,
    defaultVal: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      // min: 10,
      // max: 100,
      // step: 5,
      rangeValue: this.defaultVal,
    };
  },
  computed: {
    min() {
      if (this.options.length && this.options.length > 0) {
        const optionsAsInt = this.options
          .map((option) => parseInt(option))
          .sort((a, b) => (a > b ? 1 : -1));
        return Math.min(...optionsAsInt);
      }
      return 10;
    },
    max() {
      if (this.options.length && this.options.length > 0) {
        const optionsAsInt = this.options
          .map((option) => parseInt(option))
          .sort((a, b) => (a > b ? 1 : -1));
        return Math.max(...optionsAsInt);
      }
      return 100;
    },
    step() {
      if (this.options.length && this.options.length > 0) {
        if (this.options.length === 1) return 0;
        else {
          // TODO inform client that they cannot have different steps, they need to have a standard step across the product
          const differences = [];
          const optionsAsInt = this.options
            .map((option) => parseInt(option))
            .sort((a, b) => (a > b ? 1 : -1));
          for (let x = 0; x <= optionsAsInt.length - 2; x++) {
            if (optionsAsInt[x + 1]) {
              differences.push(optionsAsInt[x + 1] - optionsAsInt[x]);
            }
          }
          return Math.floor(
            differences.reduce((sum, next) => sum + next, 0) /
              differences.length
          );
        }
      }
      return 5;
    },
  },
  mounted() {
    this.setFill(this.rangeValue);
  },
  updated() {
    if (this.defaultVal !== this.rangeValue) this.rangeValue = this.defaultVal;
    this.setFill(this.rangeValue);
    this.$emit("slider-updated");
  },
  watch: {
    rangeValue: function (newValue) {
      this.setFill(newValue);
      this.$emit("range-value-changed", newValue);
    },
  },
  methods: {
    setFill(fillValue) {
      var value = ((fillValue - this.min) / (this.max - this.min)) * 100;
      this.$refs.slider.style.background =
        "linear-gradient(to right, #3a3830 0%, #3a3830 " +
        value +
        "%, #e6e6e6 " +
        value +
        "%, #e6e6e6 100%)";
    },
  },
};
</script>
<style scoped>
label {
  text-align: left;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  display: block;
}
.slider {
  -webkit-appearance: none !important;
  width: 98%;
  height: 5px;
  border-radius: 25px;
  background: #e6e6e6;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  cursor: pointer;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: #3a3830;
  background-image: none;
  border-color: #3a3830;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-animation: none;
  animation: none;
  width: 14px;
  height: 14px;
  border-radius: 20px;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  background-color: #3a3830;
  background-image: none;
  border-color: #3a3830;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-animation: none;
  animation: none;
  width: 14px;
  height: 14px;
  border-radius: 20px;
  cursor: pointer;
}
</style>
